import { Guide } from "types";
import { xolaUri } from "../api/xolaUri";

export const getPhotoUrl = (sellerId: ID, guideId: ID, pictureId: ID, size = "medium") => {
    return `${xolaUri}/api/sellers/${sellerId}/guides/${guideId}/picture?size=${size}&${pictureId}`;
};

export const needForceConfirm = (guide: Guide) => {
    return guide.overlappingEvents?.forceConfirm ?? true;
};

export const isOverlappingAllowed = (guide: Guide) => {
    return guide.overlappingEvents?.enabled ?? false;
};
